export default __webpack_public_path__ + "static/media/home_adjust_avatar.5bb19db0.svg";